import React from 'react';

import Login from './Login.js';

const RenewPasswordDone = () => {

  return (
    <Login>
      <div className="Login-formulaire">
        <p className="Login-info">Please check your email and click the provided link to finish resetting your password.</p>
      </div>
    </Login>
  );
}

export default RenewPasswordDone;
